import React, { useEffect, useState } from 'react';
import './css/Register.css';
import './css/ListedMachinePrefs.css';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import Switch from '@mui/material/Switch';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/AddCircle';
import {CircularProgress, IconButton} from "@mui/material";
import TextField from "@mui/material/TextField";
import Cookies from "js-cookie";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import Dialog from '@mui/material/Dialog';
import {
    Check,
    CheckCircle,
    CheckCircleOutlined,
    CheckCircleOutlineRounded,
    CheckCircleRounded,
    CloudUpload,
    CloudUploadOutlined,
    Email,
    EmailOutlined,
    Language,
    LanguageOutlined,
    NetworkCell,
    RemoveCircle,
    SmartToyTwoTone,
    Web,
    Webhook,
    WebhookOutlined,
    WebhookTwoTone,
    X
} from "@mui/icons-material";
import {Link} from "react-router-dom";
import {ArrowRightIcon} from "@mui/x-date-pickers";
function ListedMachinePrefs({ onSwitchToListings } ) {
    return <MachinesSection onSwitchToListings={onSwitchToListings}/>;
}

function MachinesSection({onSwitchToListings}) {
    const [machines, setMachines] = useState([]);
    const [newMachineId, setNewMachineId] = useState('');
    const [authToken, setAuthToken] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [isAdding, setIsAdding] = useState(false);


    const fetchMachines = () => {
        setLoading(true);
        const token = Cookies.get('auth');
        if (token) {
            setAuthToken(token);
            fetch(`../api/events/getMacEventPrefs?token=${encodeURIComponent(token)}`)
                .then(response => response.json())
                .then(data => {
                    setMachines(data);
                    setLoading(false);
                })
                .catch(error => {
                    console.error('Error fetching machines:', error);
                    setLoading(false);
                });
        } else {
            console.log('No token present in cookies.');
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchMachines();
    }, []);

    const handleAddMachine = () => {
        setIsAdding(true);
        const isExisting = machines.some(machine => machine.eventPrefsEntity.machineId === newMachineId);
        if (isExisting) {
            setErrorMessage('Machine already added.');
            setIsAdding(false);
            return;
        }

        // If newMachineId is unique, attempt to add the machine
        fetch(`../api/license/createLicense?token=${encodeURIComponent(authToken)}&m_id=${newMachineId}`, {
            method: 'GET', // Assuming GET, update if necessary
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Machine does not exist');
                }
                return response.json();
            })
            .then(data => {
                setMachines(currentMachines => [...currentMachines, data]);
                setNewMachineId('');
                setErrorMessage('');
                setIsAdding(false);
            })
            .catch(error => {
                setErrorMessage(error.message);
                setIsAdding(false);
            });
    };

    const handleDeleteMachine = (machineId) => {
        // Construct the URL with machineId
        const url = `../api/license/delLicense?token=${encodeURIComponent(authToken)}&m_id=${machineId}`;

        // Perform the fetch request
        fetch(url, {
            method: 'GET', // Assuming GET, update if necessary
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to delete machine');
                }
                // Optionally, filter out the deleted machine from the machines state
                setMachines(currentMachines => currentMachines.filter(machine => machine.eventPrefsEntity.machineId !== machineId));
            })
            .catch(error => {
                console.error('Error deleting machine:', error);
                alert('Error deleting machine');
            });
    };

    return (
       <div className="SectionListed">
        <div className="SectionEmbedded">
            <div className="SectionLtr">
              <span className="SectionBoxEmbedded">
                  <span className="SectionSubHeadingEmbedded">VAST ETL EVENTS</span>
                  <span className="SectionSubHeadingExtraEmbedded "> AGENT ACLIENT </span>
                  {loading ? (
                      // Show spinner in the center when loading
                      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                          <CircularProgress />
                      </div>
                  ) : (
                      // Render machines list if not loading and machines are available
                      machines && machines.length > 0 && (
                          <div>
                              <div className="divLineDualGrad"></div>
                              <div className="table-container">
                                  <Table className="listingsTable">
                                      <TableHeader />
                                      <TableData machines={machines} onDelete={handleDeleteMachine} setMachines={setMachines} authToken={authToken} />
                                  </Table>
                              </div>
                              <div className="divLineDualGrad"></div>
                          </div>
                      )
                  )}
                  <span className="_button_holder">
              <Button
                  variant="text"
                  size="medium"
                  startIcon={<ArrowRightIcon />}
                  onClick={onSwitchToListings}>
                BACK TO LISTED
              </Button>
            </span>
              </span>
            </div>
        </div>
       </div>

    );
}

function TableHeader() {
    return (
        <tr className="trHeader">
            <td>Machine</td>
            <td>Offers Rented</td>
            <td>Offers Vacant</td>
            <td>Errors</td>
            <td>Timeout</td>
            <td>Verification</td>
            <td>Actions</td>
        </tr>
    );
}

function TableData({ machines, onDelete, setMachines, authToken }) {
    const [originalMachines, setOriginalMachines] = useState({});
    const [editModes, setEditModes] = useState({});
    const [confirmDialog, setConfirmDialog] = useState({ open: false, machine: null, price: 0 });
    const [isVastEtlSub, setIsVastEtlSub] = useState(false);
    const [isListingSub, setIsListingSub] = useState(false);
    const [isEtlDisabled, setIsEtlDisabled] = useState(false);
    const [isListingDisabled, setIsListingDisabled] = useState(false);

    const handleRentedEmailSwitchChange = (machineId, isEnabled) => {
            setMachines(currentMachines => currentMachines.map(machine => {
                if (machine.eventPrefsEntity.machineId === machineId) {
                    console.log('Machine status updated successfully');
                    return {
                        ...machine,
                        eventPrefsEntity: {
                            ...machine.eventPrefsEntity,
                            rentedEmail: isEnabled,
                        }
                    };
                }
                return machine;
            }));
    };

    const handleSwitchChange = (machineId, eventType, isEmail, isEnabled) => {
        setMachines(currentMachines =>
            currentMachines.map(machine => {
                if (machine.eventPrefsEntity.machineId === machineId) {
                    const field = `${eventType}${isEmail ? 'Email' : 'WebHook'}`;
                    console.log(`Updated ${field} for machine ${machineId} to ${isEnabled}`);
                    return {
                        ...machine,
                        eventPrefsEntity: {
                            ...machine.eventPrefsEntity,
                            [field]: isEnabled,
                        },
                    };
                }
                return machine;
            })
        );
    };

    const toggleEdit = (machineId) => {
        setMachines(currentMachines => currentMachines.map(machine => {
            if (machine.eventPrefsEntity.machineId === machineId) {
                const isEditing = !machine.isEditable;
                if (isEditing) {
                    // Save the original state before editing
                    setOriginalMachines({
                        ...originalMachines,
                        [machineId]: { ...machine }
                    });
                } else {
                    // Clear the original state after editing
                    const newOriginals = { ...originalMachines };
                    delete newOriginals[machineId];
                    setOriginalMachines(newOriginals);
                }
                return { ...machine, isEditable: isEditing };
            }
            return machine;
        }));
    };



    const handleCancelEdit = (machineId) => {
        setMachines(currentMachines => currentMachines.map(machine => {
            if (machine.eventPrefsEntity.machineId === machineId) {
                return { ...originalMachines[machineId], isEditable: false };
            }
            return machine;
        }));
        const newOriginals = { ...originalMachines };
        delete newOriginals[machineId];
        setOriginalMachines(newOriginals);
    };


    function handleSubmitChanges(machineId) {
        const machineIndex = machines.findIndex(m => m.eventPrefsEntity.machineId === machineId);
        if (machineIndex === -1) {
            console.error('Machine not found');
            return;
        }

        // Clone the current state to have a backup in case we need to revert
        const originalMachines = [...machines];
        const updatedMachine = { ...machines[machineIndex], isEditable: false }; // Exit edit mode

        // Optimistically update the UI
        setMachines(currentMachines =>
            currentMachines.map((m, index) => (index === machineIndex ? updatedMachine : m))
        );

        // Construct the payload from the eventPrefsEntity
        const eventPrefs = updatedMachine.eventPrefsEntity;
        const payload = {
            token: authToken,
            e_id: eventPrefs.id,
            m_id: eventPrefs.machineId,
            rented_email: eventPrefs.rentedEmail,
            rented_webhook: eventPrefs.rentedWebHook,
            vacant_email: eventPrefs.vacantEmail,
            vacant_webhook: eventPrefs.vacantWebHook,
            error_email: eventPrefs.errorEmail,
            error_webhook: eventPrefs.errorWebHook,
            timeout_email: eventPrefs.timeoutEmail,
            timeout_webhook: eventPrefs.timeoutWebHook,
            verification_email: eventPrefs.verificationEmail,
            verification_webhook: eventPrefs.verificationWebHook,
        };

        // Convert payload to query parameters
        const queryParams = new URLSearchParams(payload).toString();
        const url = `../api/events/updateEventPrefs?${queryParams}`;

        fetch(url, {
            method: 'GET', // Matching your original method; consider POST for sensitive data
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to update event preferences');
                }
                return response.json();
            })
            .then(data => {
                console.log('Event preferences updated successfully');
                // Optionally update state with response data if the API returns updated preferences
            })
            .catch(error => {
                console.error('Error updating event preferences:', error);
                // Revert to the original state since the update failed
                setMachines(originalMachines);
                alert('Failed to update event preferences');
            });
    }

    return(
        <tbody>
        {machines.map(machine => (
            <tr key={machine.eventPrefsEntity.machineId} style={{ backgroundColor: machine.isEditable ? '#305772' : 'transparent' }}>
                <td>
                    <input value={machine.eventPrefsEntity.machineId} className="tableData"/>
                    <div className="tdGpuInfo">{`${machine.machineEntity.gpuName} x ${machine.machineEntity.numGpus}`}</div>

                </td>
                <td>
                    <div className="switch-container">

                            <Switch
                                size="small"
                                checked={machine.eventPrefsEntity.rentedEmail}
                                disabled={!machine.isEditable}
                                onChange={(e) => handleSwitchChange(machine.eventPrefsEntity.machineId, 'rented', true, e.target.checked)}
                            />

                        <EmailOutlined style={{ fontSize: 'medium', verticalAlign: 'bottom', textAlign: 'right', color: "lightgreen" }}/>
                    </div>

                    <div className="switch-container">

                            <Switch
                                size="small"
                                checked={machine.eventPrefsEntity.rentedWebHook}
                                disabled={!machine.isEditable}
                                onChange={(e) => handleSwitchChange(machine.eventPrefsEntity.machineId, 'rented', false, e.target.checked)}
                            />

                        <CloudUploadOutlined style={{ fontSize: 'medium', verticalAlign: 'bottom', textAlign: 'right', color: "lightblue" }}/>
                    </div>
                </td>
                <td>
                    <div className="switch-container">

                        <Switch
                            size="small"
                            checked={machine.eventPrefsEntity.vacantEmail}
                            disabled={!machine.isEditable}
                            onChange={(e) => handleSwitchChange(machine.eventPrefsEntity.machineId, 'vacant', true, e.target.checked)}
                        />

                        <EmailOutlined style={{ fontSize: 'medium', verticalAlign: 'bottom', textAlign: 'right', color: "lightgreen" }}/>
                    </div>

                    <div className="switch-container">

                        <Switch
                            size="small"
                            checked={machine.eventPrefsEntity.vacantWebHook}
                            disabled={!machine.isEditable}
                            onChange={(e) => handleSwitchChange(machine.eventPrefsEntity.machineId, 'vacant', false, e.target.checked)}
                        />

                        <CloudUploadOutlined style={{ fontSize: 'medium', verticalAlign: 'bottom', textAlign: 'right', color: "lightblue" }}/>
                    </div>
                </td>
                <td>
                    <div className="switch-container">

                        <Switch
                            size="small"
                            checked={machine.eventPrefsEntity.errorEmail}
                            disabled={!machine.isEditable}
                            onChange={(e) => handleSwitchChange(machine.eventPrefsEntity.machineId, 'error', true, e.target.checked)}
                        />

                        <EmailOutlined style={{ fontSize: 'medium', verticalAlign: 'bottom', textAlign: 'right', color: "lightgreen" }}/>
                    </div>

                    <div className="switch-container">

                        <Switch
                            size="small"
                            checked={machine.eventPrefsEntity.errorWebHook}
                            disabled={!machine.isEditable}
                            onChange={(e) => handleSwitchChange(machine.eventPrefsEntity.machineId, 'error', false, e.target.checked)}
                        />

                        <CloudUploadOutlined style={{ fontSize: 'medium', verticalAlign: 'bottom', textAlign: 'right', color: "lightblue" }}/>
                    </div>
                </td>
                <td>
                    <div className="switch-container">

                        <Switch
                            size="small"
                            checked={machine.eventPrefsEntity.timeoutEmail}
                            disabled={!machine.isEditable}
                            onChange={(e) => handleSwitchChange(machine.eventPrefsEntity.machineId, 'timeout', true, e.target.checked)}
                        />

                        <EmailOutlined style={{ fontSize: 'medium', verticalAlign: 'bottom', textAlign: 'right', color: "lightgreen" }}/>
                    </div>

                    <div className="switch-container">

                        <Switch
                            size="small"
                            checked={machine.eventPrefsEntity.timeoutWebHook}
                            disabled={!machine.isEditable}
                            onChange={(e) => handleSwitchChange(machine.eventPrefsEntity.machineId, 'timeout', false, e.target.checked)}
                        />

                        <CloudUploadOutlined style={{ fontSize: 'medium', verticalAlign: 'bottom', textAlign: 'right', color: "lightblue" }}/>
                    </div>
                </td>
                <td>
                    <div className="switch-container">

                        <Switch
                            size="small"
                            checked={machine.eventPrefsEntity.verificationEmail}
                            disabled={!machine.isEditable}
                            onChange={(e) => handleSwitchChange(machine.eventPrefsEntity.machineId, 'verification', true, e.target.checked)}
                        />

                        <EmailOutlined style={{ fontSize: 'medium', verticalAlign: 'bottom', textAlign: 'right', color: "lightgreen" }}/>
                    </div>

                    <div className="switch-container">

                        <Switch
                            size="small"
                            checked={machine.eventPrefsEntity.verificationWebHook}
                            disabled={!machine.isEditable}
                            onChange={(e) => handleSwitchChange(machine.eventPrefsEntity.machineId, 'verification', false, e.target.checked)}
                        />

                        <CloudUploadOutlined style={{ fontSize: 'medium', verticalAlign: 'bottom', textAlign: 'right', color: "lightblue" }}/>
                    </div>
                </td>



                {machine.isEditable ? (
                    <>
                        <td>
                            <div className="switch-container">
                                <IconButton color="success" size="small"
                                            onClick={() => handleSubmitChanges(machine.eventPrefsEntity.machineId)}>
                                    <CheckCircleIcon/>
                                </IconButton>

                                <IconButton color="error" size="small" onClick={() => handleCancelEdit(machine.eventPrefsEntity.machineId)}>
                                <CancelIcon />
                                </IconButton>
                            </div>
                        </td>
                    </>
                ) : (
                    <>
                        <td>
                            <IconButton color="primary" size="small" onClick={() => toggleEdit(machine.eventPrefsEntity.machineId)}>
                                <EditIcon />
                            </IconButton>
                        </td>

                    </>
                )}




            </tr>
        ))}
        </tbody>
    );
}

function AddButton({ onClick }) {
    return (
        <Button variant="contained" size="medium" startIcon={<AddIcon />} onClick={onClick}>
            Add
        </Button>
    );
}
function AgentLicensesButton() {

    return (
        <Button  variant="outlined" startIcon={< ArrowRightIcon/>}>
            BACK TO LISTED MACHINES
        </Button>
    );
}


export default ListedMachinePrefs;
